import React, { useEffect, useMemo } from "react";
import { Line } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import { fetchGraphOne } from "../../redux/actions";
import { useTranslation } from "react-i18next";

const GraphOne = ({ settings }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const graphFetchedData = useSelector(
    (state) => state.analytics.orders_statistics
  );

  useEffect(() => {
    dispatch(fetchGraphOne());
  }, []);

  const One = useMemo(() => {
    return (
      <Line
        className="graph profit-graph"
        data={{
          labels: graphFetchedData.allOrders,
          datasets: [
            {
              label: "Profit from car",
              data: graphFetchedData.profit,
              backgroundColor: "royalblue",
              tension: 0.4,
              fill: true,
            },
          ],
        }}
        options={{
          ...settings,
          maintainAspectRatio: true,
        }}
      />
    );
  }, [graphFetchedData]);

  return (
    <>
      <div className="chart-info">
        <h2>{t("graphOneTitle")}</h2>
        <p className="descr">{t("graphOneDescription")}</p>
        <div className="chart-info-extra">
          <p>
            {t("totalProfit")}:{" "}
            <strong>
              {graphFetchedData.profit.length &&
                graphFetchedData.profit.reduce((total, num = 0) => {
                  return total + num;
                })}
            </strong>
          </p>
          <p>
            {t("carsRented")}:{" "}
            <strong>{graphFetchedData.allOrders.length}</strong>
          </p>
        </div>
      </div>
      {One}
    </>
  );
};

export default React.memo(GraphOne);
